import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {OperationLogComponent} from './operation-log.component';


export const operationLogRoutes: Routes = [
  {
    path: 'operation-log',
    component: OperationLogComponent,
    data: {
      'expectedRoles': ['Admin','IT']
    },
  }
];

@NgModule({
  imports: [RouterModule.forChild(operationLogRoutes)],
  exports: [RouterModule]
})
export class OperationLogRoutingModule {
}



// WEBPACK FOOTER //
// /opt/app/src/app/features/operation-log/operation-log-routing.module.ts